import axios from "axios";

const instance = axios.create({
  baseURL: "https://www.googleapis.com/identitytoolkit/v3/relyingparty"
});

instance.defaults.headers.get["Accepts"] = "application/json";

// instance.defaults.headers.common['SOMETHING'] = 'Something';

export default instance;
